import { isBoolean, isObject } from 'lodash';
import { getMetadataName } from 'utils/getMetadata.js';

export default entity => {
    const extra = entity?.extra || {};

    if (Object.entries(extra).length === 0) {
        return [];
    }

    const attributes = [];

    attributes.push({ label: 'Metadatas', styleLabel: { fontWeight: 'bold' } });

    Object.keys(extra).sort().forEach(key => {
        const label = getMetadataName(key);

        let content = extra[key];

        if (isObject(content)) {
            content = JSON.stringify(content);
        }

        if (isBoolean(content)) {
            content = content ? 'Yes' : 'No';
        }

        attributes.push({ label, content });
    });

    return attributes;
};
